import PortfolioPlaylistEditor from '../PortfolioPlaylistEditor'
import DndProviderWrapper from 'components/DndProviderWrapper/DndProviderWrapper'
import getPortfolioStyles from 'utils/getPortfolioStyles'
import { useEffect, useState } from 'react'

const TemplatePlayerOnly = ({ values, onChange, isPreview }) => {
  const playlistStyles = getPortfolioStyles(values?.pageData?.playlistRegion)
  const [rerenderKey, setReRenderKey] = useState(Math.random())
  const [secondKey, setSecondKey] = useState(Math.random())
  useEffect(() => {
    setReRenderKey(Math.random())
  }, [values.template])

  useEffect(() => {
    setSecondKey(Math.random())
  }, [rerenderKey])
  return (
    <div className=" template-container min-w-full min-h-full">
      <div className="p-4 pb-10 h-full" style={playlistStyles}>
        <div className="max-w-[1280px] mx-auto">
          <DndProviderWrapper
            className="w-full h-full flex flex-col"
            key={rerenderKey}
          >
            <PortfolioPlaylistEditor
              values={values}
              onChange={onChange}
              isPreview={isPreview}
            />
          </DndProviderWrapper>
        </div>
      </div>
    </div>
  )
}

export default TemplatePlayerOnly
